import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createLogin } from "../Service/AdminLoginService";
import { useToast } from "../Components/toast/ToastProvider";

const Login = ({onLogin}) => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await createLogin({ email, password });
            toast(response.message || "Login successful 🎉");
            onLogin(email);
            navigate("/");
            setEmail("");
            setPassword("");
        } catch (error) {
            if (error.response && error.response.data) {
                const errData = error.response.data;
                const errMsg = errData.message || errData.error || "Login failed";
                alert(errMsg, "ERROR");
            } else {
                toast("Network or server error", "ERROR");
            }
            console.error("Login error:", error);
        }
    };
  return (
    <>
      <div className="login-page vh-100">
        {/* <video loop autoPlay muted id="vid">
          <source src="/image/bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}

        <div className="p-4">
          <h2 className="text-white my-0">Welcome Back</h2>
          <p className="text-white text-50">Sign in to continue</p>

          <form className="mt-5 mb-4"onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email" className="text-white">
                User ID
              </label>
              <input
                type="text"
                placeholder="Enter User ID"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => {
                const value = e.target.value;
                setEmail(value);
               }}
               style={{backgroundColor:'transparent'}}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="text-white">
                Password
              </label>
              <input
                type="password"
                placeholder="Enter Password"
                className="form-control"
                id="password"
                 value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{backgroundColor:'transparent'}}
                />
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-block"
            style={{borderColor:'transparent'}}>
              Login
            </button>

            {/* <div className="py-2">
              <button
                type="button"
                className="btn btn-lg btn-facebook btn-block"
              >
                <i className="feather-facebook"></i> Connect with Facebook
              </button>
            </div> */}
          </form>

          {/* <a href="/forgot-password" className="text-decoration-none">
            <p className="text-white text-center">Forgot your password?</p>
          </a> */}
        </div>

        {/* <div className="fixed-bottom d-flex align-items-center justify-content-center">
          <a href="/signup">
            <p className="text-center text-white m-0">
              Don't have an account? Sign up
            </p>
          </a>
        </div> */}
      </div>

      {/* SIDE NAV */}
      <nav id="main-nav">
        <ul className="second-nav">
          <li>
            <a href="/"><i className="feather-grid mr-2"></i> Intro</a>
          </li>
          <li>
            <a href="/landing"><i className="feather-layers mr-2"></i> Landing</a>
          </li>
          <li>
            <a href="/home"><i className="feather-home mr-2"></i> Homepage</a>
          </li>

          <li>
            <a href="#"><i className="feather-edit-2 mr-2"></i> Authentication</a>
            <ul>
              <li><a href="/login">Login</a></li>
              <li><a href="/signup">Register</a></li>
              <li><a href="/forgot-password">Forgot Password</a></li>
              <li><a href="/verification">Verification</a></li>
              <li><a href="/location">Location</a></li>
              <li><a href="/select-country">Select Country</a></li>
            </ul>
          </li>
        </ul>

        <ul className="bottom-nav">
          <li className="email">
            <a className="text-danger" href="/home">
              <p className="h5 m-0">
                <i className="feather-home text-danger"></i>
              </p>
              Home
            </a>
          </li>

          <li className="github">
            <a href="/faq">
              <p className="h5 m-0">
                <i className="feather-message-circle"></i>
              </p>
              FAQ
            </a>
          </li>

          <li className="ko-fi">
            <a href="/contact-us">
              <p className="h5 m-0">
                <i className="feather-phone"></i>
              </p>
              Help
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Login;
